import { useState } from "react";
import { CiDiscount1, CiCircleRemove, CiUser } from "react-icons/ci"
import { Input } from "../inputs/inputs";
import './sellerCode.css'

type Props = {
    sellerCode: string
    setSellerCode: (value: string) => void
    removeSellerCode: () => Promise<void>
    findSeller: (value: string) => Promise<any>
}

function SellerCodeInput({ sellerCode, setSellerCode, removeSellerCode, findSeller }: Props) {
    const [hasSellerCode, setHasSellerCode] = useState(sellerCode ? true : false)
    return (
        <div className="seller-code-input">
            {hasSellerCode ? (
                <div className="seller-code-info">
                    <div className="seller-code-info_discount" >
                        <span >
                            <b> Código do Vendedor: </b>  {sellerCode}

                        </span>
                        <CiUser size='24px' color="#6E7586" />
                    </div>
                    <CiCircleRemove size='24px' color="#d7044e" onClick={() => {
                        removeSellerCode();
                        setHasSellerCode(false);
                    }} />
                </div>
            ) : (
                <>
                    <Input
                        inputAttr={{
                            type: 'default',
                        }}
                        name="typeFreight"
                        placeholder={`Adicione um código do vendedor`}
                        value={sellerCode}
                        change={(value: string) => {
                            setSellerCode(value)
                        }}
                        blur={() => {
                            setHasSellerCode(true)
                            findSeller(sellerCode)
                        }}
                    />
                </>
            )



            }


        </div>
    )
}

export default SellerCodeInput;